import { Component, TemplateRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { RootState } from '../../../root-store/root.state';
import { ImagingService } from '../../../services/imaging/imaging.service';
import { selectViewerConnected } from '../../../connectivity/connectivity.selectors';
import { TranslateService } from '@ngx-translate/core';
import { UserConfigurationSettingsService } from '../../../services/settings/user-configuration-settings.service';
import { EWebViewerType } from 'estensa-module';
import { seOpenViewer } from '../../../root-store/root.actions';


@Component({
    selector: 'se-header-connectivity',
    templateUrl: './se-header-connectivity.component.html',
    styleUrls: ['./se-header-connectivity.component.scss'],
    standalone: false,
})
export class SeHeaderConnectivityComponent {
    @ViewChild('viewerInfoTemplate') viewerInfoTemplate: TemplateRef<unknown>;

    viewerState$ = combineLatest([
        this.store.pipe(select(selectViewerConnected)),
        from(this.imaging.getCurrentViewerType()),
    ]).pipe(
        map(([viewerOpen, viewerType]) => ({
            enabled: this.isVNextViewerEnabled(viewerType),
            icon: viewerOpen ? 'desktop_windows' : 'desktop_access_disabled',
            tooltip: this.getViewerStateTranslation(this.isVNextViewerEnabled(viewerType)),
        })),
    );

    constructor(
        private imaging: ImagingService,
        private store: Store<RootState>,
        private translate: TranslateService,
        private userConfigurationSettingsService: UserConfigurationSettingsService,
    ) {}

    async openViewer() {
        const isViewerOpen = await this.imaging.isViewerOpen();
        if (isViewerOpen) {
            return;
        }
        //chiamare action specifica
        this.store.dispatch(seOpenViewer());
    }

    private isVNextViewerEnabled(viewerType: EWebViewerType): boolean {
        const vNextViewerTypes = [EWebViewerType.EstensaReviewVNext, EWebViewerType.SeWebViewer, EWebViewerType.ZEfiRO];

        return (
            vNextViewerTypes.includes(viewerType) &&
            this.userConfigurationSettingsService.isAuthorized(['viewer_Get'], 'single')
        );
    }

    getViewerStateTranslation(enabled: boolean) {
        return enabled ? this.translate.instant('ViewerConnected') : this.translate.instant('ViewerDisconnected');
    }
}
